import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISchemeState, ISchemeResponse} from "./type"
import { fetchScheme } from "./asyncThunk";

const initialState: ISchemeState = {
  isLoading: false,
  url: ""
}

const schemeSlice = createSlice({
  name: "scheme",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchScheme.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchScheme.fulfilled, (state, action: PayloadAction<ISchemeResponse[]>) => {
        state.url = action.payload[0].img_url;
        state.isLoading = false;
      })
      .addCase(fetchScheme.rejected, (state) => {
        state.isLoading = false;
      })
  }
})

export default schemeSlice.reducer;